document.addEventListener('DOMContentLoaded', () => {

    const progress = document.querySelector('.lw-reading-progress');
    const bar = document.querySelector('.lw-reading-progress__bar');

    const trigger = document.querySelector('.article-template');
    const content = document.querySelector('#lw-article-content');

    const header =
        document.querySelector('.header-wrapper') ||
        document.querySelector('header');

if (!progress || !bar || !trigger || !content) {
    console.warn('Lunelle Editorial: required elements not found.');
    return;
}

    function headerHeight() {

        return document.querySelector('.header-wrapper')?.offsetHeight || 0;

    }

    function updateHeaderVariable() {

        document.documentElement.style.setProperty(
            '--header-height',
            headerHeight() + 'px'
        );

    }

    function updateProgress() {

        const headerH = headerHeight();

        /* -------------------------
           SHOW / HIDE
        ------------------------- */

        const triggerRect = trigger.getBoundingClientRect();

        if (triggerRect.top > headerH) {

            progress.classList.remove('is-visible');
            bar.style.width = '0%';
            return;

        }

        progress.classList.add('is-visible');

        /* -------------------------
           ARTICLE PROGRESS
        ------------------------- */

        const articleStart =
            content.offsetTop;

        const articleEnd =
            articleStart + content.offsetHeight;

        const current =
            window.scrollY + headerH;

        let percentage =
            ((current - articleStart) /
            (articleEnd - articleStart)) * 100;

        percentage = Math.max(
            0,
            Math.min(percentage, 100)
        );

        //console.log("Setting width to:", percentage + "%");

        bar.style.width = "50%";

        bar.style.width = percentage + '%';

        // Elegant completion cue
        if (percentage >= 99.8) {
            progress.classList.add('is-complete');
        } else {
            progress.classList.remove('is-complete');
        }

        // TEMPORARY DEBUG
        /*console.log({
            articleStart,
            articleEnd,
            current,
            percentage
        });*/

    }

    updateHeaderVariable();
    updateProgress();
    
    /*----------------------------------
    Reading Progress
    ----------------------------------*/
    let ticking = false;

    window.addEventListener('scroll', () => {

        if (!ticking) {

            requestAnimationFrame(() => {

                updateProgress();
                ticking = false;

            });

            ticking = true;

        }

    }, { passive: true });

    window.addEventListener('resize', () => {

        updateHeaderVariable();
        updateProgress();

    });

    /*----------------------------------
    Comfort Reflection
    ----------------------------------*/
    const reflection = document.getElementById('lw-comfort-reflection');

    if (!reflection || !content) return;

    const paragraphs = content.querySelectorAll('p');

    if (paragraphs.length >= 4) {

        paragraphs[3].insertAdjacentElement('afterend', reflection);

    } else {

        content.appendChild(reflection);

    }

});

